import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlugX = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M13.55 17.733a5.806 5.806 0 0 1 -7.356 -4.052a5.81 5.81 0 0 1 1.537 -5.627l2.054 -2.054l7.165 7.165" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 20l3.5 -3.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 4l-3.5 3.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M20 9l-3.5 3.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 16l4 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M20 16l-4 4" })
	]
});
const ForwardRef = forwardRef(SvgPlugX);
export default ForwardRef;
